export const GET_TRADE_SUB_TRADES = 'trade_sub_trades/GET_TRADE_SUB_TRADES'
export const START_LOADING_TRADE_SUB_TRADES = 'trade_sub_trades/START_LOADING_TRADE_SUB_TRADES'
export const STOP_LOADING_TRADE_SUB_TRADES = 'trade_sub_trades/STOP_LOADING_TRADE_SUB_TRADES'
export const FAIL_TRADE_SUB_TRADES = 'trade_sub_trades/FAIL_TRADE_SUB_TRADES'
